module.exports = __webpack_public_path__ + "static/media/ic_categories_gadget.bb81021f.svg";